// @flow

// Defines human-readable versions of KeyboardEvent.keyCode:
// https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
const keyCodes = {
  Enter: 13,
  Space: 32,
};

export default keyCodes;
